/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plannamepremium2Inputs */

const en_plannamepremium2 = /** @type {(inputs: Plannamepremium2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const de_plannamepremium2 = /** @type {(inputs: Plannamepremium2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

/**
* | output |
* | --- |
* | "Premium" |
*
* @param {Plannamepremium2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plannamepremium2 = /** @type {((inputs?: Plannamepremium2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plannamepremium2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plannamepremium2(inputs)
	return de_plannamepremium2(inputs)
});
export { plannamepremium2 as "planNamePremium" }